//
// Copyright 2022 DXOS.org
//

import { type PublicKey } from '@dxos/keys';
import { log } from '@dxos/log';
import { type Credential, type ProfileDocument } from '@dxos/protocols/buf/dxos/halo/credentials_pb';

import { getCredentialAssertion, issuerOf, subjectIdOf } from '../credentials/index.ts';
import { type CredentialProcessor } from './credential-processor.ts';

export type ProfileStateMachineProps = {
  identityKey: PublicKey;
  onUpdate?: () => void;
};

/**
 * Processes device invitation credentials.
 */
export class ProfileStateMachine implements CredentialProcessor {
  // TODO(burdon): Return values via getter.
  public profile?: ProfileDocument;

  constructor(private readonly _params: ProfileStateMachineProps) {}

  async processCredential(credential: Credential): Promise<void> {
    const assertion = getCredentialAssertion(credential);
    switch (assertion.$typeName) {
      case 'dxos.halo.credentials.IdentityProfile': {
        if (
          !issuerOf(credential).equals(this._params.identityKey) ||
          !subjectIdOf(credential).equals(this._params.identityKey)
        ) {
          log.warn('Invalid profile credential', { expectedIdentity: this._params.identityKey, credential });
          return;
        }

        // TODO(dmaretskyi): Extra validation for the credential?
        this.profile = assertion.profile;
        log('updated profile', {
          identityKey: this._params.identityKey,
          profile: this.profile,
        });
        this._params.onUpdate?.();
        break;
      }
    }
  }
}
